import companyGeneralDataReducer from '../redux/companyGeneralData';
import featuresReducer from "../redux/features";

export const reducers = {
  features: featuresReducer,
  companyGeneralDataById: companyGeneralDataReducer,
};
